
import Vue from "vue";

export default Vue.extend({
  name: "SettlementSummaryComparison",
  props: {
    amount: { type: Number, default: 0 },
    growthRateText: { type: String, default: "" },
    positiveTone: {
      type: String,
      default: "blue",
      validator: (value: string) => ["blue", "red", "warning"].includes(value),
    },
    negativeTone: {
      type: String,
      default: "red",
      validator: (value: string) => ["blue", "red", "warning"].includes(value),
    },
    previousPeriodName: { type: String, default: "이전 기간" },
    hasPrevious: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    needsPreviousData: { type: Boolean, default: false },
    title: { type: String, default: "" },
  },
  computed: {
    changeTone(): string {
      if (this.amount > 0) return this.positiveTone;
      if (this.amount < 0) return this.negativeTone;
      return "secondary";
    },
    changeBadgeClass(): string {
      return `badge-${this.changeTone}`;
    },
    changeIconClass(): string {
      if (this.amount > 0) {
        return `mdi-arrow-up text-${this.positiveTone}`;
      }
      if (this.amount < 0) {
        return `mdi-arrow-down text-${this.negativeTone}`;
      }
      return "mdi-minus";
    },
    changeLabel(): string {
      if (this.amount === 0) return `${this.previousPeriodName} 동일`;
      const sign = this.amount > 0 ? "+" : "-";
      return `${sign}${Math.abs(this.amount).toLocaleString()}원`;
    },
  },
});
